// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index.js";
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/resetui.css'
import Qs from "qs";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'babel-polyfill'
import PinchZoom from 'vue-pinch-zoom';
import JSONbig from "json-bigint"
import {description} from '../package.json';
Vue.component('pinch-zoom', PinchZoom);

Vue.use(Vant);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse=[(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];
// const host = process.env.NODE_ENV === "development" ? "http://api.stock.com/" : "https://pc_apiserver5618.hk9999.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
console.log(description);
let lineURL = localStorage.getItem('lineUrl');

if (!lineURL) {
  localStorage.setItem('lineUrl', process.env.API_ROOT);
  const instance = axios.create({
    baseURL: process.env.API_ROOT,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;

} else {
  const instance = axios.create({
    baseURL: localStorage.getItem('lineUrl'), //process.env.API_ROOT
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;
}

/**
 * wonder chat system start
 */

const wonderChatInstace = axios.create({
  baseURL: process.env.WONDER_CHAT_ROOT,
  timeout: 10000,
  withCredentials: true
});
Vue.prototype.$wonderChat = wonderChatInstace;

//end wonder chat system
//Vue.prototype.$http = instance;

Vue.prototype.$chatApiURL = process.env.WONDER_CHAT_ROOT;//"https://chat.hk99555.com/";

let Line_1 = process.env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = process.env.Line_2;//"https://server3299.hk99111.com/";



Vue.prototype.$URLs = [{ "id": 1, "name": "线路 1", "url": process.env.API_ROOT }, { "id": 2, "name": "线路 2", "url": Line_1 }, { "id": 3, "name": "线路 3", "url": Line_2 }];

//force logout and goto login
Vue.prototype.$logout = function (msg) {
  this.$toast.fail(msg);
  setTimeout(() => {
    this.$store.commit("changeLoginType", false);
    sessionStorage.setItem("token", "");
    localStorage.clear();
    this.$router.push("/login");
    window.location.reload();
  }, 2000);
};

// Common loader
Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";
// Vue.prototype.$ShowCommonLoading = function () {
//   return this.$toast.loading({
//     duration: 0, // 持续展示 toast
//     forbidClick: true,
//     overlay: true,
//     message: "加载中...",
//   });
// };
// const host = process.env.NODE_ENV === "development" ? "/" : "https://server.hk9999z.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
// const instance = axios.create({
//   baseURL: host,
//   timeout: 10000,
//   withCredentials: true
// });
// Vue.prototype.$http = instance;
// 添
/* eslint-disable no-new */

Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


// WEBPACK FOOTER //
// ./src/main.js